import { render } from "./AjouterOrganePage.vue?vue&type=template&id=67b59321&ts=true"
import script from "./AjouterOrganePage.vue?vue&type=script&lang=ts"
export * from "./AjouterOrganePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__